import React, { useState } from "react";
import { Dropdown, Layout, Menu, Space } from "antd";
import { LogoutOutlined } from "@ant-design/icons";

import AppSideBar from "./AppSideBar";
import { clearLocalStorage } from "../utils/storageUtil";
import history from "../utils/history";
import { JWT_TOKEN } from "../constant";

const { Content, Footer, Header } = Layout;
const AdminLayout = ({ children }) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [width, setWidth] = useState(window.innerWidth);
  const [navCollapsed, setNavCollapsed] = useState(false);

  window.addEventListener("resize", () => {
    setWidth(window.innerWidth);
  });

  const menu = (
    <Menu
      onClick={() => {
        clearLocalStorage(JWT_TOKEN);
        history.push("/");
      }}
    >
      <Menu.Item>
        <a target="_blank" rel="noopener noreferrer">
          Logout
        </a>
      </Menu.Item>
    </Menu>
  );

  return (
    <Layout className="gx-app-layout">
      <AppSideBar
        sidebarCollapsed={sidebarCollapsed}
        setSidebarCollapsed={setSidebarCollapsed}
        navCollapsed={navCollapsed}
        setNavCollapsed={setNavCollapsed}
      />
      <Layout>
        <Header style={{ background: "#ffff", height: `${width < 500 ? '100px' : '60px'}` }}>
          <div className="gx-linebar gx-mr-3">
            {width < 992 && (
              <i
                className="gx-icon-btn icon icon-menu"
                onClick={() => {
                  setNavCollapsed(!navCollapsed);
                }}
              />
            )}
          </div>
          <Dropdown overlay={menu} style={{ float: "right" }}>
            <a onClick={(e) => e.preventDefault()}>
              <Space>
                {/* <Avatar
                  size={40}
                  src={userData?.[0]?.profileImage ? `data:image/jpeg;base64,${userData?.[0]?.profileImage}` : <UserOutlined />}
                />{" "}
                {decoded?.username} <DownOutlined /> */}
                <LogoutOutlined style={{ fontSize: "20px" }} />
              </Space>
            </a>
          </Dropdown>
        </Header>
        <Content className={`gx-layout-content`}>
          <div
            style={{
              margin: window.innerWidth < 700 ? "" : "24px 16px",
              padding: window.innerWidth < 700 ? 10 : 24,
            }}
          >
            {children}
          </div>
        </Content>
        <Footer>
          <div className="gx-layout-footer-content">
            Copyright DBAN © {new Date().getFullYear()}
          </div>
        </Footer>
      </Layout>
    </Layout>
  );
};

export default AdminLayout;